/** Tab slugs for client (company) details — mirrored in the URL as `/clients/:companyId/:tab`. */
export const CLIENT_DETAILS_TAB_VALUES = ['contacts', 'pricebook', 'about'] as const;

export type ClientDetailsTab = (typeof CLIENT_DETAILS_TAB_VALUES)[number];

export const CLIENT_DETAILS_TAB_LABELS: Record<ClientDetailsTab, string> = {
  contacts: 'Contacts',
  pricebook: 'Pricebook',
  about: 'About',
};

export const CLIENT_DETAILS_TABS: Array<{ label: string; value: ClientDetailsTab }> =
  CLIENT_DETAILS_TAB_VALUES.map((value) => ({
    label: CLIENT_DETAILS_TAB_LABELS[value],
    value,
  }));

export const isClientDetailsTab = (value: string | undefined | null): value is ClientDetailsTab =>
  Boolean(value && (CLIENT_DETAILS_TAB_VALUES as readonly string[]).includes(value));

export const DEFAULT_CLIENT_DETAILS_TAB: ClientDetailsTab = 'contacts';

export const getClientDetailsHref = (
  companyId: string,
  tab: ClientDetailsTab = DEFAULT_CLIENT_DETAILS_TAB
): string => `/clients/${encodeURIComponent(companyId)}/${tab}`;
